module.exports = __webpack_public_path__ + "static/media/0170_Small.bf72a1a7.jpg";